import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';

export const useSuccessMessage = () => {
  const { t } = useTranslation();

  const generateSuccessMessage = (
    actionType: string,
    entityName: string,
    recordCount?: number
  ): string => {
    const capitalizedAction =
      actionType.charAt(0).toUpperCase() + actionType.slice(1);
    const capitalizedEntity =
      entityName.charAt(0).toUpperCase() + entityName.slice(1);

    if (actionType === 'export' && recordCount !== undefined) {
      return t('successMessages.exportCompleted', { recordCount });
    }

    return t('successMessages.actionCompleted', {
      actionType: capitalizedAction,
      entityName: capitalizedEntity,
    });
  };

  return { generateSuccessMessage };
};

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
